<form class="contact__form" (submit)="onSubmit($event)" [formGroup]="contactForm">
    <div class="contact__input-wrapper">
        <mat-radio-group aria-label="Select an option" formControlName="gender" style="width: 100%;">
            <mat-radio-button value="1">{{"auth.fields.gender.male" | translate}}</mat-radio-button>
            <mat-radio-button value="2">{{"auth.fields.gender.female" | translate}}</mat-radio-button>
            <mat-radio-button value="3">{{"auth.fields.gender.other" | translate}}</mat-radio-button>
        </mat-radio-group>
        <mat-icon [ngClass]="getFormControlIconClassname('gender')" color="primary" aria-label="check"
            svgIcon="check"></mat-icon>
    </div>

    <div class="contact__field__wrapper">
        <div class="contact__input-wrapper">
            <mat-form-field appearance="fill" class="input">
                <mat-label>{{ "auth.fields.firstName" | translate }}</mat-label>
                <input matInput formControlName="firstName" (keydown.enter)="$event.preventDefault()" />
            </mat-form-field>
            <mat-icon class="contact__input__check-icon-hidden" color="primary" aria-label="check"></mat-icon>
        </div>
        <div class="contact__input-wrapper">
            <mat-form-field appearance="fill" class="input">
                <mat-label>{{ "auth.fields.lastName" | translate }}</mat-label>
                <input matInput formControlName="lastName" (keydown.enter)="$event.preventDefault()" />
            </mat-form-field>
            <mat-icon [ngClass]="getFormControlIconClassname(['firstName', 'lastName'])" color="primary"
                aria-label="check" svgIcon="check"></mat-icon>
        </div>
    </div>
    <div class="contact__input-wrapper">
        <mat-form-field appearance="fill" class="input">
            <mat-label>{{ "auth.fields.email" | translate }}</mat-label>
            <input matInput autocomplete="email" type="email" formControlName="email"
                (keydown.enter)="$event.preventDefault()" />
        </mat-form-field>
        <mat-icon [ngClass]="getFormControlIconClassname('email')" color="primary" aria-label="check"
            svgIcon="check"></mat-icon>
    </div>
    <div class="contact__field__wrapper">
        <div class="contact__input-wrapper">
            <mat-form-field appearance="fill" class="input">
                <mat-label>{{ "auth.fields.landline_phone_number" | translate }}</mat-label>
                <input matInput formControlName="landlinePhoneNumber" (keydown.enter)="$event.preventDefault()" />
            </mat-form-field>
            <mat-icon class="contact__input__check-icon-hidden" color="primary" aria-label="check"></mat-icon>
        </div>
        <div class="contact__input-wrapper">
            <mat-form-field appearance="fill" class="input">
                <mat-label>{{ "auth.fields.mobile_phone_number" | translate }}</mat-label>
                <input matInput formControlName="mobilePhoneNumber" (keydown.enter)="$event.preventDefault()" />
            </mat-form-field>
            <mat-icon [ngClass]="getFormControlIconClassname(['landlinePhoneNumber','mobilePhoneNumber'])"
                color="primary" aria-label="check" svgIcon="check"></mat-icon>
        </div>
    </div>
    <div class="contact__input-wrapper">
        <mat-form-field appearance="fill">
            <mat-label>Votre question concerne</mat-label>
            <mat-select value="any" formControlName="questionType">
                <mat-option value="1">Les courses</mat-option>
                <mat-option value="2">Les qualifications</mat-option>
                <mat-option value="3">Les licences professionnelles et contrats</mat-option>
                <mat-option value="4">L'abonnement au Bulletin Officiel</mat-option>
                <mat-option value="5">L'élevage - le stud-book</mat-option>
                <mat-option value="6">Infonet</mat-option>
                <mat-option value="7">Votre compte professionnel</mat-option>
                <mat-option value="8">L'international</mat-option>
                <mat-option value="9">Les petites annonces</mat-option>
                <mat-option value="10">Les opérations thèmatiques des hippodromes</mat-option>
                <mat-option value="11">La boutique</mat-option>
                <mat-option value="12">Notre site web</mat-option>
                <mat-option value="13">L'Union Européenne du Trot</mat-option>
                <mat-option value="14">Le centre d'entraînement de Grosbois</mat-option>
                <mat-option value="15">Autre</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-icon [ngClass]="getFormControlIconClassname(['landlinePhoneNumber','mobilePhoneNumber'])" color="primary"
            aria-label="check" svgIcon="check"></mat-icon>
    </div>
    <div class="contact__message-wrapper">
        <mat-form-field class="example-full-width">
            <mat-label>Votre message</mat-label>
            <textarea  placeholder="Ex. It makes me feel..."
                formControlName="message"
                matInput
                cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="11"></textarea>
        </mat-form-field>
    </div>
    <div class="contact__actions">
        <button type="submit" [disabled]="!contactForm.valid" mat-raised-button color="primary"
            class="actions__submit">
            <div class="actions__button-container">
                ENVOYER
                <mat-icon aria-hidden="send" aria-label="send" svgIcon="send"></mat-icon>
            </div>
        </button>
    </div>
</form>